import { schema } from "normalizr"
import licence from "../licences/item"

export default new schema.Entity("modules", { licence }, { idAttribute: "moduleId" })
